import { Injectable } from '@angular/core';
import { Actions, AppStore } from '../index';
import { WebPreferences } from '../../app/modules/chart/interface/interfaces';
import { ReduxAction, ReduxType } from '../interface';

@Injectable()
export class PreferencesAction extends Actions {
  constructor(appStore: AppStore) {
    super(appStore);
  }

  public updatePreferences(
    preferences: WebPreferences
  ): ReduxAction<WebPreferences> {
    return { type: ReduxType.PREFERENCES, payload: preferences };
  }
}
